import { createTRPCReact } from '@trpc/react-query'

import { type TRPCRouter } from '../router'

/**
 * TRPC client for Client Components
 */
export const trpc = createTRPCReact<TRPCRouter>()
